export default __webpack_public_path__ + "static/media/prize-1.c59e3c46.webp";